if (!customElements.get('sensa-pdp-assurances')) {
  customElements.define('sensa-pdp-assurances', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const button = this.querySelector('[data-sensa-proof-open]');
      const proof = document.getElementById(button?.getAttribute('aria-controls'));
      if (!button || !proof) return;
      const options = { signal: this.controller.signal };
      const syncExpanded = () => button.setAttribute('aria-expanded', String(proof.open));
      button.addEventListener('click', () => {
        proof.open = true;
        syncExpanded();
        proof.querySelector('summary').focus({ preventScroll: true });
        proof.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      proof.addEventListener('toggle', syncExpanded, options);
      syncExpanded();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
